interface IPlainError {
  code: string;
  message: string;
}

export default class CodeMessageError extends Error {
  public code: string;
  public message: string;

  constructor(code: string, message: string) {
    super();
    this.name = "CodeMessageError";
    this.code = code;
    this.message = message;
  }

  public toJSON(): IPlainError {
    return {
      code: this.code,
      message: this.message,
    };
  }
}
